import { FC } from "react";
import { EditorialDetailsPage } from "@companion-core/shared/app/Components/DetailsPages/EditorialDetailsPage";
import { ContentDetailsPage } from "@companion-core/shared/app/Components/DetailsPages/ContentDetailsPage";
import { ContentTemplate } from "@companion-core/shared/app/Components/DetailsPages/Templates/Content";
import { ContentTemplateProps } from "@companion-core/shared/app/Components/DetailsPages/Templates/Content/contentTemplate.model";

export interface DetailsPageProps {
  id?: string;
  fromOnboarding?: boolean;
}

export interface CommonDetailsPageProps {
  id: string;
  contentType?: string;
  origin?: string;
  fromOnboarding?: boolean;
}

export interface DetailsPageRouteProps {
  origin?: string;
  contentType?: string;
  id?: string;
}

export const DETAILS_PAGES: {
  [key: string]: FC<CommonDetailsPageProps>;
} = {
  "offer": ContentDetailsPage,
  "event": ContentDetailsPage,
  "editorial": EditorialDetailsPage,
  "vendor": ContentDetailsPage,
  "inspiration": ContentDetailsPage,
};

export const EDITORIAL_PAGES: {
  [key: string]: FC<ContentTemplateProps>;
} = {
  "inspirations": ContentTemplate,
  "magazines": ContentTemplate,
};

export const getDetailPageType = (
  origin: string,
  exceptions?: string[]
): FC<CommonDetailsPageProps> => {
  if (exceptions?.includes(origin)) {
    return EditorialDetailsPage;
  } else {
    return ContentDetailsPage;
  }
};
